import { module as m } from 'modujs';

export default class extends m {
    constructor(m) {
        super(m);

        // EVENTS
        this.events = {
            'mouseenter': {
                'item': '_hover'
            },
            'mouseleave': {
                'item': '_leave'
            }
        }
    }

    init() {
        const _elts = this.el.querySelectorAll('.submenu__item a');
        _elts.forEach(item => {
            item.addEventListener('mouseenter', () => {
                if(item.querySelector('.illustration svg'))
                    this.call('play', {}, 'Lottie', item.querySelector('.illustration').dataset.moduleLottie);
            });
            item.addEventListener('mouseleave', () => {
                if(item.querySelector('.illustration svg'))
                    this.call('pause', {}, 'Lottie', item.querySelector('.illustration').dataset.moduleLottie);
            });
        })
    }

    /**
     * HOVER
     * @private
     */
    _hover(e) {
        e.currentTarget.classList.add('visible');
    }

    /**
     * LEAVE
     * @private
     */
    _leave(e) {
        e.currentTarget.classList.remove('visible');
    }
}
